import { render } from "./ContactView.vue?vue&type=template&id=235a229e&scoped=true"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=235a229e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235a229e"]])

export default __exports__